import { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { initializeAuthState } from '../store/slices/authSlice';
import { fetchMetadataFields, fetchMetadataDistinct } from '../store/slices/metadataSlice';
import Loading from './Common/Loading';

const ReduxAuthProvider = ({ children }) => {
  const dispatch = useAppDispatch();
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const initializedRef = useRef(false);
  const [initialCheckComplete, setInitialCheckComplete] = useState(false);

  // Initialize auth state only once
  useEffect(() => {
    if (!initializedRef.current) {
      initializedRef.current = true;
      dispatch(initializeAuthState()).finally(() => {
        // Mark initial check as complete regardless of success/failure
        setInitialCheckComplete(true);
      });
    }
  }, [dispatch]);

  // Fetch metadata when user becomes authenticated
  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchMetadataFields());
      dispatch(fetchMetadataDistinct());
    }
  }, [dispatch, isAuthenticated]);

  // Show loading only during initial auth check
  if (!initialCheckComplete) {
    return <Loading message="Initializing..." size="fullscreen" />;
  }

  return children;
};

export default ReduxAuthProvider;
